<template>
  <AltModal
    :open="etat.ouvert"
    :title="etat.titre"
    size="sm"
    @update:open="(o: boolean) => !o && repondre(false)"
  >
    <!-- `data-confirmation` : le repère de la règle de premier plan (main.css). -->
    <div class="space-y-3" data-confirmation>
      <p class="whitespace-pre-line text-sm text-slate-600 dark:text-alt-dark-muted">
        {{ etat.message }}
      </p>

      <!-- CE QUI PART AVEC, nommé. Le liseré porte le niveau à lui seul, comme
           partout ailleurs (cf. `.pa-note` dans main.css) : on lit la forme
           avant la couleur. -->
      <div
        v-if="etat.details?.length"
        class="rounded-lg border-l-2 px-3 py-2 text-sm"
        :class="
          etat.danger
            ? 'border-amaranth bg-amaranth/5 text-slate-600 dark:text-alt-dark-muted'
            : 'border-steel-azure bg-alice-blue text-slate-600 dark:bg-alt-dark-raised dark:text-alt-dark-muted'
        "
      >
        <p class="mb-1 font-medium" :class="etat.danger ? 'text-amaranth' : 'text-steel-azure'">
          {{ etat.danger ? 'Seront emportés :' : 'Ce que cela change :' }}
        </p>
        <ul class="list-inside list-disc space-y-0.5">
          <li v-for="d in etat.details" :key="d">{{ d }}</li>
        </ul>
      </div>

      <!-- La voie douce, quand elle existe : dans presque tous les cas, c'est
           elle que la personne voulait. -->
      <p v-if="etat.repli" class="text-xs text-slate-400">{{ etat.repli }}</p>
    </div>

    <template #footer>
      <div class="flex justify-end gap-2">
        <AltButton variant="ghost" @click="repondre(false)">Annuler</AltButton>
        <AltButton :variant="etat.danger ? 'danger' : 'primary'" @click="repondre(true)">
          {{ etat.action }}
        </AltButton>
      </div>
    </template>
  </AltModal>
</template>

<script setup lang="ts">
import { etatConfirmation as etat, repondre } from '@/lib/confirmer';

/**
 * L'HÔTE DES CONFIRMATIONS — monté une seule fois, dans la coquille.
 *
 * Il ne décide de rien : il rend l'état posé par `confirmer()` et rend la
 * réponse. Un composant par point d'appel aurait dispersé la charte dans sept
 * fichiers, et c'est exactement ce qu'on vient de corriger.
 *
 * FERMER, C'EST REFUSER. La croix, la touche Échap et le clic à côté rendent
 * `false` : devant une suppression, le doute doit toujours retenir le geste.
 */
</script>
